"use client";

import { frame, motion, useSpring } from "motion/react";
import projWindowImg from '../proj_window.png';
import "../index.css";

export function OpenProjects() {
    return (
        <motion.div
            className="project-window-container"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1 }}
        >

            <img src={projWindowImg} className="project-window-img" />
            <div className="project-window-text font-link">
                <p>game log <a href="https://poobie123.com/" target="_blank">( link )</a> 
                    <br /> - web application 
                </p>
            </div>
        </motion.div>
    );
}

export default OpenProjects;